let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let radio = require("ES/lib/react-pubsub-via-radio.js/radio");
let esUtils = require("ES/utils/esUtils");
let FormMixin = require("react-loose-forms");
let FormUtils = require("../../../../../utils/FormUtils");
let dateformat = require("ES/lib/dateformat");
let FormButtons = require("react-loose-forms.bootstrap3/layouts/FormButtons");
let StatusBoxes = require("./StatusBoxes");
let EventFormUnsavedChangeMixin = require("../../EventFormUnsavedChangeMixin");

let ParticipantBlock = dd.createClass({
    mixins: [FormMixin, EventFormUnsavedChangeMixin],
    getInitialValuesSourceVersion({event}){
        return esUtils.getEventVersionIdentifier(event);
    },

    getInitialValues({participant}){
        let values = {
            id: participant.id,//hidden (so __onSubmit knows which id it is)
            name: participant.name
        };
        _.each(participant.sessions, function (s) {
            values["startdate_" + s.id] = s.startdate;
            values["complete_" + s.id] = !!esUtils.getIn(s, ["flags_as_map", "complete", "is_set"]);
        });
        return values;
    },

    buildSchema(){
        let {participant} = this.props;
        let schema = {
            name: {
                type: "text",
                validate: FormUtils.v.optional
            }
        };
        _.each(participant.sessions, function (s) {
            schema["startdate_" + s.id] = {
                type: "date",
                validate: FormUtils.v.optional
            };
            schema["complete_" + s.id] = {
                type: "checkbox",
                validate: FormUtils.v.optional
            };
        });
        return schema;
    },
    getInitialState(){
        return {is_open: false, edit_mode: false};
    },
    __toggleOpen: esUtils.wrapPreventDefault(function () {
        this.setState({
            is_open: !this.state.is_open,
            edit_mode: false
        });
    }),
    __toggleEditMode: esUtils.wrapPreventDefault(function () {
        let {read_only} = this.props;
        if (read_only) {
            if (this.state.edit_mode) {
                this.setState({edit_mode: false, is_open: true});
            }
            return;
        }
        this.setState({
            is_open: true,
            edit_mode: !this.state.edit_mode
        });
    }),
    __cancelEdits: esUtils.wrapPreventDefault(function () {
        this.__discardChanges();
        this.setState({is_open: true, edit_mode: false});
    }),
    render(){
        let fields = this.Form_buildSchema();
        let errors = this.state.errors || {};
        let {participant, read_only} = this.props;
        let {is_open, edit_mode} = this.state;

        let buildField = _.bind(function (field_name) {
            let error = errors[field_name];
            return dd.div({className: error ? "has-error" : null},
                this.Form_buildInput(fields[field_name]),
                error ? dd.span({className: "help-block"}, error) : null
            );
        }, this);

        return dd.div({className: "panel panel-" + (participant.id === 0 ? "primary" : "default"), style: {marginBottom: 0}},
            dd.div({className: "panel-heading"},
                read_only ? null : dd.div({className: "pull-right", style: {marginLeft: "1em"}},
                    dd.a({
                            href: "#",
                            onClick: this.__toggleEditMode,
                            style: participant.id === 0 ? {color: "white"} : {}
                        },
                        dd.i({className: "fa fa-edit"})
                    )
                ),
                dd.div({className: "pull-right"},
                    StatusBoxes({sessions: participant.sessions})
                ),
                dd.h4({className: "panel-title"},
                    dd.a({
                            href: "#",
                            onClick: this.__toggleOpen
                        },
                        dd.i({className: "fa fa-caret-" + (is_open ? "down" : "right")}),
                        " ",
                        participant.id === 0 ? "Team Sessions" : participant.name
                    )
                )
            ),
            is_open ? dd.div({className: "panel-body"},
                dd.form({onSubmit: this.Form_onSubmit},
                    participant.id !== 0 && edit_mode ? buildField("name") : null,
                    dd.table({className: "table", onClick: edit_mode ? null : this.__toggleEditMode},
                        dd.thead(null,
                            dd.tr(null,
                                dd.th(null, "Session Date"),
                                dd.th({style: {width: "1px"}}, "Complete")
                            )
                        ),
                        dd.tbody(null,
                            _.map(participant.sessions, function (s) {
                                let is_checked = !!esUtils.getIn(s, ["flags_as_map", "complete", "is_set"]);

                                return dd.tr({key: s.id},
                                    dd.td(null,
                                        edit_mode
                                            ? buildField("startdate_" + s.id)
                                            : _.isDate(s.startdate) ? dateformat(s.startdate, dateformat.masks.mediumDate) : "- -"
                                    ),
                                    dd.td({className: "text-center"},
                                        edit_mode
                                            ? buildField("complete_" + s.id)
                                            : dd.i({className: "fa fa-" + (is_checked ? "check-" : "") + "square-o"})
                                    )
                                );
                            }, this)
                        )
                    ),
                    edit_mode
                        ? FormButtons({onCancel: this.__cancelEdits, right_align: true})
                        : null
                )
            ) : null
        );
    }
});

module.exports = dd.createClass({
    __onSubmit(data){
        let event = _.cloneDeep(this.props.event);
        ///////////////////////////////////////////

        _.each(event.VideoCoaching, function (p) {
            if (p.id === data.id) {
                p.name = data.name;
                _.each(p.sessions, function (s) {
                    if (_.has(data, "complete_" + s.id)) {
                        s.flags_as_map.complete.is_set = !!data["complete_" + s.id];
                    }
                    if (_.has(data, "startdate_" + s.id)) {
                        s.startdate = data["startdate_" + s.id];
                    }
                });
            }
        });

        ///////////////////////////////////////////
        radio("save_Event").broadcast(event);
    },
    render(){
        let {event, read_only} = this.props;
        /*
         participants:        esUtils.getIn(event, ["key_values", "PARTICIPANTS"]),
         individual_sessions: esUtils.getIn(event, ["key_values", "INDIVIDUAL_SESSIONS"]),
         team_sessions:       esUtils.getIn(event, ["key_values", "TEAM_SESSIONS"])
         */
        return dd.div(null,
            _.map(_.sortBy(event.VideoCoaching, function (p) {
                return (p.id === 0 ? "z" : "a") + p.id;
            }), function (p) {
                return ParticipantBlock({
                    key: p.id,
                    event,
                    read_only,
                    participant: p,
                    onSubmit: this.__onSubmit
                });
            }, this)
        );
    }
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/coaching/CoachingScheduler.js